<template>
  <button class="shared-step-editor-header-button" @click="$emit('clicked')" :disabled="disabled">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
  },
};
</script>

<style lang="scss">
.shared-step-editor-header-button {
  background: #b5e6e5;
  color: #399999;
  display: flex;
  align-items: center;
  &:hover {
    background: #399999;
    color: #b5e6e5;
  }
}
</style>
